<script>
  import Input from '../private/Input';
  import { useFieldState } from '../Field/FieldStateProvider.svelte';

  const fieldState = useFieldState();

  export let name;
  export let value = '';
  export let label = undefined;
  export let placeholder = undefined;
  export let disabled = false;
  export let testid = undefined;

  export let error = false;
  export let warning = false;
  export let leftIcon = undefined;
  export let rightIcon = undefined;

  export let newBrand = false;

  $: availableLabel = label ?? (fieldState && $fieldState.label);
  $: applyLabel = typeof availableLabel === 'function' ? availableLabel : () => {};
  $: accessibilityLabel = typeof availableLabel === 'string' ? availableLabel : undefined;

  let input;
  export function focus() {
    input.focus();
  }
  export function blur() {
    input.blur();
  }
</script>

<Input {disabled} {error} {warning} {leftIcon} {rightIcon} {newBrand}>
  <input
    type='password'
    bind:this={input}
    bind:value
    on:change
    on:input
    {name}
    {placeholder}
    {disabled}
    use:applyLabel
    aria-label={accessibilityLabel}
    data-cy={testid} />
</Input>
